import React from 'react';
import PropTypes from 'prop-types';
import './USPV2.css';

/**
 * USPV2 — a quiet strip of label / value pairs separated by hairlines
 * (LEVERANS · 2–4 dagar, BETALNING · Kort · Swish, …). Unlike `USP` it has
 * no icons and no Trustpilot slot.
 *
 * Figma (OVER-LL): Desktop `2217:151754`, Mobile `2645:13348`.
 *
 * - Items flagged `hideOnMobile` disappear below 1024px (Figma keeps two of
 *   four on the phone).
 * - The divider belongs to the item it precedes (`li + li::before`), so a
 *   hidden middle item leaves no double rule.
 */
const USPV2 = ({ items = [], className = '' }) => {
  if (items.length === 0) return null;

  return (
    <section className={`ds-usp-v2${className ? ` ${className}` : ''}`}>
      <ul className="ds-usp-v2__list">
        {items.map(({ label, value, hideOnMobile }) => (
          <li
            key={label}
            className={`ds-usp-v2__item${hideOnMobile ? ' ds-usp-v2__item--hide-mobile' : ''}`}
          >
            <span className="ds-usp-v2__text">
              <span className="ds-usp-v2__label typo-body">{label}</span>
              <span className="ds-usp-v2__value typo-body">{value}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

USPV2.propTypes = {
  /** Label / value pairs. `hideOnMobile` drops the item below 1024px. */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      hideOnMobile: PropTypes.bool,
    }),
  ),
  /** Additional CSS class */
  className: PropTypes.string,
};

export default USPV2;
